module.exports = __webpack_public_path__ + "static/img/ctrl_bg.65064be2.png";